import { CaseType, ICase } from '@brands/services/cases/types/ICase';

import { UserProfile, UserRoleName } from '../services/identity/types/UserProfile';

export const checkCollapsibleHeaderColor = (
  currentCase: ICase | null,
  userInfo: UserProfile,
  tabName: string,
): string => {
  if (currentCase) {
    // Collector: no case-level clinical edits (photos, notes, CDT, etc.); waiting room when assigned.
    if (userInfo.role.name === UserRoleName.Collector) {
      const assignedAsCollector =
        currentCase.collector_id == null || Number(currentCase.collector_id) === Number(userInfo.id);
      if (!assignedAsCollector) {
        return 'readOnly';
      }
      if (tabName === 'JoinWaitingRoom') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
          case 'accepted_provider':
          case 'in_progress_provider':
          case 'in_progress_care_advisor':
            return 'edit';
          default:
            return 'readOnly';
        }
      }
      return 'readOnly';
    }
    if (
      (Number(currentCase.care_advisor_id) === Number(userInfo.id) &&
        userInfo.role.name === UserRoleName.CareAdvisor) ||
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin
    ) {
      if (tabName === 'Images') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'editImages';
          case 'accepted_provider':
            return 'editImages';
          case 'in_progress_provider':
            return 'editImages';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'OHC') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'careCoordination') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'APPDC') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'CareCoordinationFindings') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'EditImages') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'editImages';
          case 'accepted_provider':
            return 'editImages';
          case 'in_progress_provider':
            return 'editImages';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'InternalNotes' && userInfo.role.name === UserRoleName.CareAdvisor) {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else if (
        tabName === 'InternalNotes' &&
        (userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin)
      ) {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'Notes' && userInfo.role.name === UserRoleName.CareAdvisor) {
        // Patient-visible "Case notes" (distinct from provider-only
        // "Internal case notes"). DO-3649 / DO-3967: the assigned CA can
        // add/edit these on every case status, including `completed` —
        // adding after completion is the intended way to relay additional
        // info to the patient (backend fires a new-note notification).
        switch (currentCase.status) {
          case 'accepted_care_advisor':
          case 'accepted_provider':
          case 'in_progress_provider':
          case 'in_progress_care_advisor':
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else if (
        tabName === 'Notes' &&
        (userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin)
      ) {
        // Admin roles can see but not author patient-visible case notes —
        // mirrors the 'InternalNotes' treatment for Admin above.
        return 'readOnly';
      } else if (tabName === 'JoinWaitingRoom') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'Education') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'RemoveMedia') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'editImages';
          case 'accepted_provider':
            return 'editImages';
          case 'in_progress_provider':
            return 'editImages';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'ViewNotes') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'editImages';
          case 'in_progress_care_advisor':
            return 'editImages';
          case 'completed':
            return 'editImages';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'Assessment') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'Pharmacy') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      }
    } else if (
      Number(currentCase.provider_id) === Number(userInfo.id) &&
      userInfo.role.name === UserRoleName.Provider
    ) {
      if (tabName === 'JoinWaitingRoom') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'APPDC') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'EditImages') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'editImages';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'editImages';
          case 'completed':
            return 'editImages';
          default:
            return 'editImages';
        }
      } else if (tabName === 'RemoveMedia') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'editImages';
          case 'accepted_provider':
            return 'editImages';
          case 'in_progress_provider':
            return 'editImages';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'ViewNotes') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'readOnly';
          case 'in_progress_provider':
            return 'readOnly';
          case 'in_progress_care_advisor':
            return 'editImages';
          case 'completed':
            return 'editImages';
          default:
            return 'readOnly';
        }
      } else if (tabName === 'InternalNotes') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else if (tabName === 'Notes') {
        // Provider's assigned case: patient-visible notes are editable on
        // every status, matching the CA branch above. DO-3649 / DO-3967.
        switch (currentCase.status) {
          case 'accepted_care_advisor':
          case 'accepted_provider':
          case 'in_progress_provider':
          case 'in_progress_care_advisor':
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else if (tabName === 'Assessment') {
        if (currentCase.type === 'second_opinion') {
          switch (currentCase.status) {
            case 'accepted_care_advisor':
              return 'readOnly';
            case 'accepted_provider':
              return 'editNotRequired';
            case 'in_progress_provider':
              return 'editNotRequired';
            case 'in_progress_care_advisor':
              return 'readOnly';
            case 'completed':
              return 'readOnly';
            default:
              return 'readOnly';
          }
        } else {
          switch (currentCase.status) {
            case 'accepted_care_advisor':
              return 'readOnly';
            case 'accepted_provider':
              return 'edit';
            case 'in_progress_provider':
              return 'edit';
            case 'in_progress_care_advisor':
              return 'readOnly';
            case 'completed':
              return 'readOnly';
            default:
              return 'readOnly';
          }
        }
      } else if (tabName === 'E-Prescribe') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else if (tabName === 'Pharmacy') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else if (tabName === 'editPrescriptions') {
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'edit';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'edit';
          case 'completed':
            return 'edit';
          default:
            return 'edit';
        }
      } else
        switch (currentCase.status) {
          case 'accepted_care_advisor':
            return 'readOnly';
          case 'accepted_provider':
            return 'edit';
          case 'in_progress_provider':
            return 'edit';
          case 'in_progress_care_advisor':
            return 'readOnly';
          case 'completed':
            return 'readOnly';
          default:
            return 'readOnly';
        }
    } else return 'readOnly';
  } else return 'readOnly';
};

export const checkEditValid = (currentCase: ICase, userInfo: UserProfile): boolean => {
  if (
    (currentCase.care_advisor_id === userInfo.id && userInfo.role.name === UserRoleName.CareAdvisor) ||
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin
  ) {
    if (currentCase.type === CaseType.oral_health_coaching) {
      switch (currentCase?.status) {
        case 'new':
          return true;
        case 'accepted_care_advisor':
          return true;
        case 'accepted_provider':
          return true;
        case 'in_progress_provider':
          return true;
        case 'in_progress_care_advisor':
          return true;
        default:
          return true;
      }
    } else {
      switch (currentCase?.status) {
        case 'new':
          return true;
        case 'accepted_care_advisor':
          return true;
        case 'accepted_provider':
          return true;
        case 'in_progress_provider':
          return true;
        case 'in_progress_care_advisor':
          return false;
        default:
          return true;
      }
    }
  } else if (currentCase.provider_id === userInfo.id && userInfo.role.name === UserRoleName.Provider) {
    switch (currentCase?.status) {
      case 'new':
        return false;
      case 'accepted_care_advisor':
        return false;
      case 'accepted_provider':
        return false;
      case 'in_progress_provider':
        return false;
      case 'in_progress_care_advisor':
        return false;
      default:
        return false;
    }
  } else if (currentCase.care_advisor_id === userInfo.id && userInfo.role.name === UserRoleName.Collector) {
    return false;
  }
  return false;
};

// Canceling belongs to every staff role that works a case day to day, but never
// to the patient or the treating provider: the profile cases section also renders
// on a patient's own profile, where nothing else gates the status menu.
const CANCEL_ALLOWED_ROLES = new Set<string>([
  UserRoleName.SuperAdmin,
  UserRoleName.OrganizationAdmin,
  UserRoleName.Admin,
  UserRoleName.CareAdvisor,
  UserRoleName.Collector,
]);

export const canRoleCancelCase = (role: string): boolean => CANCEL_ALLOWED_ROLES.has(role);

// Completing a case means signing off on clinical work being done, which neither
// a Collector nor a Coordinator (internal role name CareAdvisor) does. Cancel
// (standalone, linked, or the whole multi-stage program) is their only close-out.
const COMPLETE_BLOCKED_ROLES = new Set<string>([UserRoleName.Collector, UserRoleName.CareAdvisor]);

export const canRoleCompleteCase = (role: string): boolean => !COMPLETE_BLOCKED_ROLES.has(role);

// "+ Add case" on a patient's journey is reserved for the roles
// accountable for managing it day to day. A plain Admin can view a
// patient's journey but not add to it: only Super Admin, Client Admin,
// Collector, and Coordinator (internal role name CareAdvisor) can.
const ADD_CASE_ALLOWED_ROLES = new Set<string>([
  UserRoleName.SuperAdmin,
  UserRoleName.OrganizationAdmin,
  UserRoleName.Collector,
  UserRoleName.CareAdvisor,
]);

export const canRoleAddCase = (role: string): boolean => ADD_CASE_ALLOWED_ROLES.has(role);

// A plain Admin acts on individual cases (complete, cancel) but never on the
// day-to-day shape of the multi-stage program around them: no pause/resume,
// no adding a case to one, no converting a standalone case into one.
const MANAGE_JOURNEY_BLOCKED_ROLES = new Set<string>([UserRoleName.Admin]);

export const canRoleManageJourney = (role: string): boolean => !MANAGE_JOURNEY_BLOCKED_ROLES.has(role);

// Canceling a whole program is an admin-accountable action rather than program
// management, so it follows the cancel-case rule: a plain Admin can cancel a
// program even though they cannot pause, resume or add to it.
export const canRoleCancelJourney = (role: string): boolean => canRoleCancelCase(role);

export const checkAllowCAToCancelCaseOnly = (currentCase: ICase, userRole: string): boolean => {
  if (userRole === UserRoleName.CareAdvisor || userRole === UserRoleName.Collector) {
    switch (currentCase?.status) {
      case 'new':
        return false;
      case 'accepted_care_advisor':
        return true;
      case 'accepted_provider':
        return true;
      case 'in_progress_provider':
        return true;
      case 'completed_by_provider':
        return true;
      case 'in_progress_care_advisor':
        return true;
      case 'completed':
        return false;
      case 'canceled':
        return false;
      default:
        return false;
    }
  }
  return false;
};

export const checkAllowCAToCancelCase = (currentCase: ICase, userInfo: UserProfile): boolean => {
  if (
    currentCase.care_advisor_id === userInfo.id &&
    (userInfo.role.name === UserRoleName.CareAdvisor || userInfo.role.name === UserRoleName.Collector)
  ) {
    switch (currentCase?.status) {
      case 'new':
        return false;
      case 'accepted_care_advisor':
        return true;
      case 'accepted_provider':
        return true;
      case 'in_progress_provider':
        return true;
      case 'in_progress_care_advisor':
        return true;
      case 'completed':
        return false;
      case 'canceled':
        return false;
      default:
        return false;
    }
  } else if (
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin
  ) {
    switch (currentCase?.status) {
      case 'new':
        return true;
      case 'accepted_care_advisor':
        return true;
      case 'accepted_provider':
        return true;
      case 'in_progress_provider':
        return true;
      case 'completed_by_provider':
        return true;
      case 'in_progress_care_advisor':
        return true;
      case 'completed':
        return false;
      case 'canceled':
        return false;
      default:
        return false;
    }
  } else if (currentCase.provider_id === userInfo.id && userInfo.role.name === UserRoleName.Provider) {
    switch (currentCase?.status) {
      case 'new':
        return false;
      case 'accepted_care_advisor':
        return false;
      case 'accepted_provider':
        return false;
      case 'in_progress_provider':
        return false;
      case 'in_progress_care_advisor':
        return false;
      case 'completed':
        return false;
      case 'canceled':
        return false;
      default:
        return false;
    }
  }
  return false;
};

export const checkEditValidForCA = (currentCase: ICase, userInfo: UserProfile): boolean => {
  if (
    userInfo.role.name === UserRoleName.CareAdvisor ||
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin
  ) {
    switch (currentCase?.status) {
      case 'new':
        return true;
      case 'accepted_care_advisor':
        return true;
      case 'accepted_provider':
        return true;
      case 'in_progress_provider':
        return true;
      case 'in_progress_care_advisor':
        return true;
      case 'completed':
        return true;
      case 'canceled':
        return true;
      default:
        return false;
    }
  }
  return false;
};

export const checkSelectionAvailability = (userInfo: UserProfile, thisCase: ICase | undefined): boolean => {
  if (thisCase)
    if (
      thisCase.care_advisor_id === userInfo.id &&
      (userInfo.role.name === UserRoleName.CareAdvisor ||
        userInfo.role.name === UserRoleName.Admin ||
        userInfo.role.name === UserRoleName.SuperAdmin ||
        userInfo.role.name === UserRoleName.OrganizationAdmin)
    ) {
      switch (thisCase?.status) {
        case 'new':
          return false;
        case 'accepted_care_advisor':
          return false;
        case 'accepted_provider':
          return false;
        case 'in_progress_provider':
          return false;
        default:
          return false;
      }
    } else if (thisCase.provider_id === userInfo.id && userInfo.role.name === UserRoleName.Provider) {
      switch (thisCase?.status) {
        case 'new':
          return false;
        case 'accepted_care_advisor':
          return false;
        case 'accepted_provider':
          return true;
        case 'in_progress_provider':
          return true;
        case 'in_progress_care_advisor':
          return false;
        default:
          return false;
      }
    }
  return false;
};
